export default [
  { label: 'Transação', value: 'protocol_number' },
  { label: 'Tipo', value: 'eventable_type' },
  { label: 'Detalhes', value: 'details' },
  { label: 'Placa do veículo', value: 'licence_plate' },
  { label: 'Vlr. Total', value: 'total_amount' },
  { label: 'Tarifas', value: 'fee_total_amount' },
  { label: 'Ret. IR', value: 'income_tax_total' },
  { label: 'Filial', value: 'branch' },
  { label: 'Cartão', value: 'card' },
  { label: 'Autor', value: 'author' },
  { label: 'Data e Hora', value: 'created_at' },
  { label: 'Ações', value: 'actions', className: 'w-0' },
]
